import { Insights } from "@mui/icons-material";
import type { ModuleDescriptor } from "src/app/moduleDescriptor";
import { MetricsDashboardPage } from "./MetricsDashboardPage.page";

/**
 * The Metrics Dashboard's route ("/", the landing page) and drawer entry.
 * TODO(CPD-99): Internal Admin-only in the POC. Set `requiredEntitlements` once
 * customer-portal-api has a Metrics entitlement and grants it; until then a
 * gate would lock everyone out of the landing page.
 */
export const metricsModule: ModuleDescriptor = {
  id: "metrics",
  path: "/",
  element: <MetricsDashboardPage />,
  nav: { label: "Metrics Dashboard", icon: <Insights />, section: "primary" },
};
